import {styled, Box, FormControlLabel, Radio} from '@mui/material'

/**
 * RadioContainer - Container for the radio group
 */
export const RadioContainer = styled(Box)(({theme, orientation}) => ({
  display: 'flex',
  flexDirection: orientation === 'horizontal' ? 'row' : 'column',
  width: '100%'
}))

/**
 * StyledRadio - Custom styled radio button
 */
export const StyledRadio = styled(Radio)(({theme}) => ({
  '&.Mui-checked': {
    color: theme.palette.primary.main
  },
  '&:hover': {
    backgroundColor: theme.palette.hpBaseLighter
  }
}))

/**
 * StyledFormControlLabel - Custom styled form control label for radio
 */
export const StyledFormControlLabel = styled(FormControlLabel)(({theme}) => ({
  margin: 0,
  borderRadius: theme.spacing(0.5),

  '& .MuiFormControlLabel-label': {
    fontSize: theme.typography.subtitle1.fontSize,
    fontWeight: theme.typography.fontWeightMedium,
    color: theme.palette.text.primary,
    userSelect: 'none'
  },
  '&.Mui-disabled': {
    opacity: 0.6
  }
}))
